import { useTranslation } from 'next-i18next';
import type { CancelPenalty } from '../types';

type Props = {
  cancelPenalty: Partial<CancelPenalty>;
  keyTextClassName?: string;
  customValueTextClassName?: string;
};

const CancelPenaltyRow = ({
  cancelPenalty,
  keyTextClassName,
  customValueTextClassName = 'text-small',
}: Props) => {
  const { t } = useTranslation();

  const getKeyText = () => {
    if (cancelPenalty.type === 'no_show') {
      return t('component:cancel_penalty_row.cancel_without_notice');
    }
    if (!cancelPenalty.deadline) {
      return t('component:cancel_penalty_row.on_the_day');
    }
    return t('component:cancel_penalty_row.days_before', { days: cancelPenalty.deadline });
  };

  const keyText = getKeyText();

  return (
    <tr>
      <td className={keyTextClassName}>{keyText}</td>
      <td className={`md:pl-12 ${customValueTextClassName}`}>
        {cancelPenalty.percentage
          ? t('component:cancel_penalty_row.cancel_fee_percentage', {
              percentage: cancelPenalty.percentage,
            })
          : t('component:cancel_penalty_row.cancel_fee', { fee: cancelPenalty.amount })}
      </td>
    </tr>
  );
};

export default CancelPenaltyRow;
